import "./modal.css";
import logo from "../../utils/imgs/logos/logo_y.png";
import data from '../../utils/data.json';
import { useLanguage } from "../../context/LanguageContext";

const Modal = ({ setShowModal }) => {

  /* ------ Context API ------ */
  const { selectedLanguage } = useLanguage();

  const content = data?.lavoraConNoi?.[selectedLanguage];
  
  const descModalStyle = () => {
    return { top: window.pageYOffset };
  };
  const closeModal = () => {
    setShowModal(false);
    window.onscroll = function () {};
  };

  return (
    <dialog
      className="descModal"
      onClick={() => closeModal()}
      style={descModalStyle()}
    >

      <div className="actual-modal_lavora_con_noi" >

        <div className="bar" />

        <div className="top-modal">
          <div className="logo-title">
            <div className="logo-container">
              <img src={logo} alt="logo" />
            </div>
            <h3 className="title_lcn">{content?.title}</h3>
          </div>
        </div>

        <div className="lcn">
          <div className="lavoraConNoi">

            <p>{content?.text1}</p>

            <p className="mailto">
              {content?.text2}&nbsp;
              <a href={`mailto:${content?.mail}`}>{content?.mail}</a>
            </p>

            <p>{content?.text3}</p>

            <ul>
              {content?.bulletPoints?.map(point => (
                <li>{point}</li>
              ))}
            </ul>

          </div>
        </div>

        <div className="btn_container">
          <button onClick={() => closeModal()}>OK</button>
        </div>

      </div>
      
    </dialog>
  );
};

export default Modal;